import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { ApplicationConfig } from '@angular/core';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideRouter, withComponentInputBinding, withEnabledBlockingInitialNavigation, withInMemoryScrolling } from '@angular/router';
import Aura from '@primeuix/themes/aura';
import { providePrimeNG } from 'primeng/config';
import { appRoutes } from './app.routes';
import { fr } from 'primelocale/js/fr.js';
import { definePreset } from '@primeuix/themes';
import { authInterceptor, autoLoginInterceptor, httpErrorInterceptor } from '@app/core/interceptors';

const appThemePreset = definePreset(Aura, {
    semantic: {
        primary: {
            50: '{teal.50}',
            100: '{teal.100}',
            200: '{teal.200}',
            300: '{teal.300}',
            400: '{teal.400}',
            500: '{teal.500}',
            600: '{teal.600}',
            700: '{teal.700}',
            800: '{teal.800}',
            900: '{teal.900}',
            950: '{teal.950}'
        }
    },
    components: {
        card: {
            root: {
                borderRadius: 'var(--p-border-radius-md)'
            }
        },
        panel: {
            root: {
                borderColor: 'transparent',
            }
        },
        togglebutton: {
            root: {
                padding: '0.25rem',
            },
            content: {
                padding: '0.25rem 0.75rem',
                borderRadius: '{content.border.radius}',
            }
        },
        progressspinner: {
            root: {
                colorOne: '{red.500}',
                colorTwo: '{blue.500}',
                colorThree: '{green.500}',
                colorFour: '{yellow.500}'
            },
        },
        galleria: {
            root: {
                borderWidth: '0',
            }
        },
        accordion: {
            header: {
                borderRadius: '0',
                first: {
                    topBorderRadius: '0',
                },
                last: {
                    bottomBorderRadius: '0',
                }
            },
            content: {
                padding: '0',
            }
        },
    }
})

export const appConfig: ApplicationConfig = {
    providers: [
        provideRouter(appRoutes, withComponentInputBinding(), withInMemoryScrolling({ anchorScrolling: 'enabled', scrollPositionRestoration: 'enabled' }), withEnabledBlockingInitialNavigation()),
        provideHttpClient(withInterceptors([authInterceptor, httpErrorInterceptor, autoLoginInterceptor])),
        provideAnimationsAsync(),
        providePrimeNG({
            translation: fr,
            theme: {
                preset: appThemePreset,
                options: {
                    darkModeSelector: '.app-dark'
                }
            },
            ripple: true
        })
    ]
};
